import ReactDom from 'react-dom/client'
import App from '@/App'

const rootEl = document.getElementById('root')
if (rootEl) {
  const root = ReactDom.createRoot(rootEl)
  root.render(<App />)
}
